import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";

export function NotFound (props) {

    return (
        <>
        <Helmet>
                <title>Not Found</title>
            </Helmet>
            
        <div class="container">
            <div class="row">
                <div class="col-12 py-5">
                    <h1>Page not found</h1>
                </div>
            </div>
            </div>
        </>
    );
}
